module.exports = __webpack_public_path__ + "img/logo-justeat.4df3c655.svg";